import MenuItemSection, { IPendingAddition, ISectionTrayTarget, ISiblingDisplayOrder } from '../../MenuSection';
import { ICategoryWithChildren } from '../utilities';
import { ISection } from 'src/types/menu.types';

interface IMenuItemSectionContainer {
  menuId: string;
  category: ICategoryWithChildren;
  handleSectionModal: (options?: ISectionTrayTarget) => void;
  handleManageAvailabilityModal: (section: ICategoryWithChildren) => void;
  onClickNewItem: (sectionId?: string) => void;
  displayOrder?: ISiblingDisplayOrder;
  isAssignedToMealtime: boolean | undefined;
  tooltipPosition: 'top' | 'bottom';
  sections: ISection[];
  isAddProductsHidden?: boolean;
  pendingAddition?: IPendingAddition;
  scrollToSectionId?: string | null;
  onScrolledIntoView?: () => void;
}

const MenuItemSectionContainer = ({ category, ...rest }: IMenuItemSectionContainer) => {
  const { children } = category;
  return (
    <MenuItemSection {...rest} section={category}>
      {children.map((subcategory: ICategoryWithChildren, index) => (
        <MenuItemSectionContainer
          key={subcategory.sectionId}
          {...rest}
          category={subcategory}
          displayOrder={{ up: children[index - 1]?.displayOrder, down: children[index + 1]?.displayOrder }}
        />
      ))}
    </MenuItemSection>
  );
};

export default MenuItemSectionContainer;
